import { IssueEntity } from 'types/IssueEntity'

export const getIssueDate = (issue: {
    ipoTradingDate: string | null
    subEndDate: string | null
    sources?: IssueEntity['sources']
}) =>
    issue.ipoTradingDate ??
    issue.subEndDate ??
    issue.sources?.find((source) => source.sourceType === 'Publication')?.publishedDate ??
    null
